export default __webpack_public_path__ + "img/794609dacd0034a7badeb728dea683f6.png";